export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID || "";

// Initialize page views
export const pageview = (url: string) => {
  // if (typeof window !== "undefined" && window.gtag) {
    // window.gtag("config", GA_TRACKING_ID, {
    //   cookie_flags: "SameSite=None; Secure",
    //   cookie_domain: "auto",
    //   page_path: url,
    //   debug_mode: true,
    // });
    return;
  // }
};

// Log custom events
export const trackEvent = ({
  action,
  category,
  label,
  value,
}: {
  action: string;
  category: string;
  label: string;
  value?: number;
}) => {
  // window.gtag("event", action, {
  //   event_category: category,
  //   event_label: label,
  //   value,
  // });
  return;
};
